<template>
  <div
    v-if="productMessage"
    style="font-size: 16px;">
    <span class="badge bg-danger">
      <i class="fa fa-exclamation-triangle"/>
      {{ shortMsg }}
    </span>
  </div>
</template>

<script setup>
  // Initialize
  import { computed } from 'vue';
  
  const props = defineProps(['productMessage'])

  // Computed
  const shortMsg = computed(()=>{
    return props.productMessage?.short_message || null
  })
  const longMsg = computed(()=>{
    return props.productMessage?.long_message || null
  })
  const company = computed(()=>{
    return props.productMessage?.company || null
  })

</script>